import { Action } from 'redux';
import { Holiday } from 'domain/Holiday';
import DomainObjectView from 'domain/DomainObjectView';
import { Map } from 'immutable';
/* eslint-disable no-shadow, no-unused-vars */

export enum ActionType {
  ADD_HOLIDAY = 'ADD_HOLIDAY',
  REMOVE_HOLIDAY = 'REMOVE_HOLIDAY',
  UPDATE_HOLIDAY = 'UPDATE_HOLIDAY',
  REFRESH_HOLIDAY_LIST = 'REFRESH_HOLIDAY_LIST',
  SET_HOLIDAY_LIST_LOADING = 'SET_HOLIDAY_LIST_LOADING'
}

export interface SetHolidayListLoadingAction extends Action<ActionType.SET_HOLIDAY_LIST_LOADING> {
  readonly isLoading: boolean;
}

export interface AddHolidayAction extends Action<ActionType.ADD_HOLIDAY> {
  readonly holiday: Holiday;
}

export interface RemoveHolidayAction extends Action<ActionType.REMOVE_HOLIDAY> {
  readonly holiday: Holiday;
}

export interface UpdateHolidayAction extends Action<ActionType.UPDATE_HOLIDAY> {
  readonly holiday: Holiday;
}

export interface RefreshHolidayListAction extends Action<ActionType.REFRESH_HOLIDAY_LIST> {
  readonly holidayList: Holiday[];
}

export type HolidayAction = SetHolidayListLoadingAction | AddHolidayAction | RemoveHolidayAction |
UpdateHolidayAction | RefreshHolidayListAction;

export interface HolidayList {
  readonly isLoading: boolean;
  readonly holidayMapById: Map<number, DomainObjectView<Holiday>>;
}
